import { render, staticRenderFns } from "./CourseReviewComments.vue?vue&type=template&id=279174e3&"
import script from "./CourseReviewComments.vue?vue&type=script&lang=ts&"
export * from "./CourseReviewComments.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports